// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tasks {
    margin-top: 3rem;
    padding: var(--content-padding-big);
}

.task {
    margin-top: 2rem;
}

.task-content {
    max-height: 0;
    overflow: hidden;
    transition: all 0.5s ease-in-out;
    border-radius: 1rem;
    background-color: #e5e4e4;
}

.task-content.visible {
    padding: 2rem 1rem;
    max-height: min-content;
}

.task__buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1rem;
    gap: 2rem;
}

.task__info {
    text-align: center;
}

.task-button {
    height: 8rem;
    padding: 1rem;
    margin: 1rem 0;
    border: 1px solid var(--black-color-light);
    border-radius: 1rem;
    cursor: pointer;
}

.task-button img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.task-button:hover {
    background-color: #f4f4f4;
}

.task-button.active {
    background-color: #f4f4f4;
}

.task-cover-container {
    background-color: var(--electric-blue-color-light);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4rem;
    overflow-x: scroll;
}

.task-cover {
    max-width: 10rem;
    min-width: 5rem;
    flex: 1 1;
}

.task-cover img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/components/tasks/tasks.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,cAAc;IACd,0CAA0C;IAC1C,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kDAAkD;IAClD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,SAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":[".tasks {\n    margin-top: 3rem;\n    padding: var(--content-padding-big);\n}\n\n.task {\n    margin-top: 2rem;\n}\n\n.task-content {\n    max-height: 0;\n    overflow: hidden;\n    transition: all 0.5s ease-in-out;\n    border-radius: 1rem;\n    background-color: #e5e4e4;\n}\n\n.task-content.visible {\n    padding: 2rem 1rem;\n    max-height: min-content;\n}\n\n.task__buttons {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 1rem;\n    gap: 2rem;\n}\n\n.task__info {\n    text-align: center;\n}\n\n.task-button {\n    height: 8rem;\n    padding: 1rem;\n    margin: 1rem 0;\n    border: 1px solid var(--black-color-light);\n    border-radius: 1rem;\n    cursor: pointer;\n}\n\n.task-button img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.task-button:hover {\n    background-color: #f4f4f4;\n}\n\n.task-button.active {\n    background-color: #f4f4f4;\n}\n\n.task-cover-container {\n    background-color: var(--electric-blue-color-light);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 4rem;\n    overflow-x: scroll;\n}\n\n.task-cover {\n    max-width: 10rem;\n    min-width: 5rem;\n    flex: 1;\n}\n\n.task-cover img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
